import { NftsProxyApi } from './NftsProxyApi.js';
export { NftsProxyApi };
export default new NftsProxyApi();
